import { render, staticRenderFns } from "./AdministrationOverview.vue?vue&type=template&id=6f33509b&"
import script from "./AdministrationOverview.vue?vue&type=script&lang=js&"
export * from "./AdministrationOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports